<template>
  <gj-modal
      v-bind="$attrs"
      v-on="$listeners"
      :visible.sync="modalVisible"
      size="full-middle"
      :no-padding="true"
      :confirmLoading="confirmLoading"
      :contentStyle="{'height': '100%', display: 'flex', 'flex-direction': 'column'}"
      @open="modalOpen"
      @cancel="cancel"
      @confirm="confirm">
    <template #header>
      <span>添加商品</span>
    </template>
    <template #content>
      <app-base-main
          :table-shadow="false"
          :no-padding="true"
          parent-table
          style="padding: 10px 10px 0;">
        <template #filter-group>
          <app-filter-group
              :reset="false"
              :query="false"
              @query="$gjNoticeQuery"
              @reset="$gjReset">
            <gj-select-input
                @confirm="$gjNoticeQuery()"
                @input="$gjNoticeQuery()"
                :singe-input="true"
                v-model="filter.keyword"
                :options="option.keyword"
                :width="['110px', '200px']"
            >
            </gj-select-input>
          </app-filter-group>

        </template>
        <template #table>
          <gj-table
              ref="gjTable"
              name="transferProductAddModal"
              :index="false"
              :loading="loading"
              :data="tableData"
              :columns="columns"
              :offset-height="54"
              adapt-parent
              selection
              :pagination="pagination"
              @sort-change="$gjSortChange"
              @page-change="$gjNoticeQuery">
            <template v-slot:productName="{row}">
              <div>
                <gj-text width="90%">{{ row.productName | defaultShow }}</gj-text>
              </div>
              <div>
                {{ row.sku | defaultShow }}
              </div>
            </template>
          </gj-table>
        </template>
      </app-base-main>
    </template>
  </gj-modal>
</template>

<script>
import {modalMixIn, queryMixin, selectionMixin} from "@/minxins";
import {getSimpleListings} from "@/api/sale";
import {postFetchSelectRows4Plan} from '@/api/logistics'
import {ProductEnum} from "@/utils/options";

export default {
  name: "delivery-plan-add-product",
  mixins: [modalMixIn, queryMixin, selectionMixin],
  props: {
    hideSkuList: {
      required: true,
      default: () => {
        return []
      }
    },
    marketId:{
      required:true,
    }
  },
  data() {
    return {
      moduleName: "app-purchase-plan-add-product-modal",
      tableData: [],
      columns: [
        {id: 'picture', header: '图片', field: 'picture:imageUrl', width: '60px'},
        {id: 'msku', header: 'MSKU', field: 'msku', minWidth: '100px'},
        {id: 'fnsku', header: 'FNSKU', field: 'fnsku', minWidth: '100px'},
        {id: 'productName', header: '产品名称/SKU', field: 'slot:productName', minWidth: '200px'},
      ],
      filter: {
        keyword: {
          key: 'mskuList',
          value: null
        },
      },
      option: {
        keyword: [
          {id: 'mskuList', 'text': "MSKU", moreShow: true},
          {id: 'fnskuList', 'text': "FNSKU", moreShow: true},
          {id: 'productName', text: '产品名称'},
          {id: 'sku', text: 'SKU'},
        ],
      },
      productTypeOption: ProductEnum.typeOption,
      confirmLoading: false,
    }
  },
  created() {
    this.sort.prop = 'sku';
  },
  methods: {
    $gjQuery() {
      // 构造查询参数
      const params = {
        model: {
          excludeMskuList: this.hideSkuList,
          marketId: this.marketId,
          statusList: [
            'InActive',
            'Active',
            'InComplete'
          ]
        },
        ...this.queryPagination,
        ...this.querySort
      };
      params.model[this.filter.keyword.key] = this.filter.keyword.value;
      if((['mskuList','fnskuList'].includes(this.filter.keyword.key))){
        if(this.filter.keyword.value){
          params.model[this.filter.keyword.key] = this.filter.keyword.value.split(',');
        }else{
          params.model[this.filter.keyword.key] = [];
        }
      }
      // 查询
      this.loading = true;
      getSimpleListings(params)
          .then((data) => {

            this.tableData = data.records;
            this.pagination = this.getPagination(data);
          })
          .complete(() => {
            this.loading = false;
          });
    },
    confirm() {
      if (this.selectedRows.length === 0) {
        this.$gjMessage.error('请勾选商品');
        return;
      }
      this.confirmLoading = true;
      postFetchSelectRows4Plan({itemList: this.selectedRows}).then(res => {
        this.$emit('select', res);
        this.$gjDestroy();
      }).complete(() => this.confirmLoading = false)
    }
  }
}
</script>

<style scoped>
</style>
